<!--
   Invite contact btn in navbar
-->
<script setup lang="ts">
/* COMPONENTS */
import { ALIconButton } from '@af-lib/vue-ui';
import { useRouter } from 'vue-router';

const router = useRouter();
</script>

<template>
  <ALIconButton
    variant="tertiary"
    icon="fas fa-user-plus"
    :label="$t('recruiter_network.list.invite')"
    :shouldTeleportTooltip="true"
    @click="router.push({ name: 'network-invite' })"
  />
</template>
